/**
 * Copyright 2024-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import type { ResourceGroupData } from "./types";

export function extractTagsExpression(group?: Partial<ResourceGroupData>) {
  return (group?.resourceSelectors ?? []).find(
    (selector) => selector?.tagsExpression
  )?.tagsExpression;
}
